import flatpickr from "flatpickr"
import {Czech} from "flatpickr/dist/l10n/cs.js"
import "flatpickr/dist/flatpickr.css"

const dates = document.querySelectorAll(".f-date")

const initializeDateField = (date: Element) => {
  const input = date.querySelector<HTMLInputElement>(".f-date__input.flatpicker")

  if (!input) return

  const isTime = date.classList.contains("--time")
  const beforeToday = date.classList.contains("--before")
  date.classList.remove("--native")
  input.type = "text"

  const flatpickerOptions: flatpickr.Options.Options = {
    enableTime: isTime,
    disableMobile: true,
    time_24hr: true,
    noCalendar: isTime,
    altInput: true,
    allowInput: true,
    altFormat: isTime ? "H:i" : "d.m.Y",
    locale: Czech,
    maxDate: beforeToday ? "today" : "",
    minDate: beforeToday ? "" : "today",
    mode: input.hasAttribute("data-range") ? "range" : "single",
  }

  flatpickr(input, flatpickerOptions)
}

dates.forEach(initializeDateField)

// Export function to initialize date fields in a specific container
export const initializeDateFields = (container: HTMLElement | Document = document) => {
  const containerDates = container.querySelectorAll(".f-date")
  containerDates.forEach(initializeDateField)
}
